import React from "react";
import { useDispatch } from "react-redux";
import { Delete, Edit, MapsUgc } from "@mui/icons-material";
import { blue, red } from "@mui/material/colors";
import RegularButton from "../../components/CustomButtons/Button";
import { COVERAGES_CONFIG, COVERAGES_PHRASE } from "./config";
import { ColumnContainer } from "../../utils/columnsStyle";
import { newDateWithTime } from "../../helpers/dateTools";
import {
  editCoverageMode, setSelectedCoverage, deleteCoverageMode
} from "../../redux/actions/coverages/coveragesActions";

export const columns = [
  {
      Header: "Fecha",
      accessor: "date",
      filterable: true,
      filterMethod: (filter, row) => String(row.date)?.toLowerCase()?.includes(filter.value.toLowerCase()),
      Cell: props => props?.value ? newDateWithTime({date: props.value, format: true}) : null,
  },
  {
    Header: () => <span>{COVERAGES_CONFIG.name.label}</span>,
    accessor: COVERAGES_CONFIG.name.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[COVERAGES_CONFIG.name.key]
        ? row[COVERAGES_CONFIG.name.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{COVERAGES_CONFIG.type.label}</span>,
    accessor: COVERAGES_CONFIG.type.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[COVERAGES_CONFIG.type.key]
        ? row[COVERAGES_CONFIG.type.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{COVERAGES_CONFIG.productType.label}</span>,
    accessor: COVERAGES_CONFIG.productType.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[COVERAGES_CONFIG.productType.key]
        ? row[COVERAGES_CONFIG.productType.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>Acciones</span>,
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const openEdit = () => {
        original.modal(true);
        dispatch(editCoverageMode());
        dispatch(setSelectedCoverage(original));
      };

      const openDelete = () => {
        original.deleteModal(true);
        dispatch(deleteCoverageMode());
        dispatch(setSelectedCoverage(original));
      };

      return (
        <ColumnContainer>
          <RegularButton
            tooltip={COVERAGES_PHRASE.page.table.actions.edit}
            round
            justIcon
            color="transparent"
            size="sm"
            onClick={openEdit}
          >
            <Edit style={{ color: blue[800] }} />
          </RegularButton>
          <RegularButton
            tooltip={COVERAGES_PHRASE.page.table.actions.delete}
            round
            justIcon
            color="transparent"
            size="sm"
            onClick={openDelete}
          >
            <Delete style={{ color: red[500] }} />
          </RegularButton>
        </ColumnContainer>
      );
    },
  },
];

export const polygonColumns = (handleRemove) => {
  return [
    {
      Header: () => "Polígono",
      accessor: "coverageName",
      filterable: false,
      sortable: false,
    },
    {
      Header: () => "Acciones",
      filterable: false,
      sortable: false,
      Cell: ({ original }) => {
        const openEdit = () => {
          original.edit(original);
        };

        const removeCoverage = () => {
          handleRemove(original);
        };

        return (
          <ColumnContainer>
            <RegularButton
              tooltip="Configurar"
              round
              justIcon
              color="transparent"
              size="sm"
              onClick={openEdit}
            >
              <MapsUgc style={{ color: blue[800] }} />
            </RegularButton>
            <RegularButton
              tooltip="Eliminar"
              round
              justIcon
              color="transparent"
              size="sm"
              onClick={removeCoverage}
            >
              <Delete style={{ color: red[500] }} />
            </RegularButton>
          </ColumnContainer>
        )
      },
    },
    {
      Header: () => "Cargada",
      accessor: "complete",
      filterable: false,
      sortable: false,
    },
  ];
};